import { URL_CANDIDATES } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';

import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';

import translations from './.vocab';

export const CandidateManagementLink = ({ jobId }: { jobId?: string }) => {
  const { t } = useTranslations(translations);
  const { localiseRoute } = useLocalisedRoutes();

  const candidatesUrl = localiseRoute(`${URL_CANDIDATES}/?jobid=${jobId}`);

  return (
    <>
      {t('candidate-management-link-text', {
        Link: (children) => (
          <TextLink href={candidatesUrl} target="_blank">
            {children}
          </TextLink>
        ),
      })}
      <br />
      {t('candidate-management-link-redirection-text')}
    </>
  );
};
